import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrCollapseToggler extends Component {
    state = {
    }

    render() {
        return (
            <span class={ 'txr-collapse-toggler' + (!this.props.isExpanded ? ' collapsed' : '')}>
                 <i class="far fa-minus txr-collapse-toggler_icon1"></i>
                 <i class="far fa-minus txr-collapse-toggler_icon2"></i>
            </span>
        )
    }
}
export default TxrCollapseToggler;